import { styled } from '@mui/material/styles';

interface RectangleProps {
  $transparent?: boolean;
}

export const Rectangle = styled('div')<RectangleProps>(({ $transparent }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
  backgroundColor: $transparent ? 'unset' : 'var(--darkGreyButtonColor)',
  color: '#c7c7d9',
  borderRadius: 'var(--buttonBorderRadius)',
  cursor: 'pointer',
}));
